import { render, staticRenderFns } from "./TakipKurForm.vue?vue&type=template&id=d5594d8c"
import script from "./TakipKurForm.vue?vue&type=script&lang=ts"
export * from "./TakipKurForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports